import { lineHeightPx } from '@atlas-frontend/design-tokens';
import { Flex } from 'antd';
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

export const AlgorithmJoinsFormRowControls: FC<PropsWithChildren> = (props) => (
  <Wrapper vertical gap="small">
    <Flex gap="small">{props.children}</Flex>
  </Wrapper>
);

const Wrapper = styled(Flex)`
  /* Spacer the same height as FormField label */
  &:before {
    content: '';
    height: ${lineHeightPx}px;
  }

  > div {
    align-items: center;
    flex-grow: 1;
  }
`;
